import { formatDate } from 'CorePackage/MainModule/common/formatDate';

export const convertInitialKnmDateToFormDate = (
  dateString: string | null | undefined,
  dateFormat: string,
  parseFormat?: string,
): string | undefined => (dateString ? formatDate({ date: dateString, dateFormat, parseFormat }) : undefined);
